(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("color"), require("coreUtilsLib"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "color", "coreUtilsLib"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash"), require("color"), require("coreUtilsLib")) : factory(root["lodash"], root["color"], root["coreUtilsLib"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var color = __webpack_require__(4);

var _require = __webpack_require__(5),
    checkIsParamAnAliasAndGetUnaliasedValue = _require.checkIsParamAnAliasAndGetUnaliasedValue;

var paramMutators = {
    //color
    brightness: function brightness(paramValue, _brightness) {
        return paramValue.value(_brightness * paramValue.hsv().v);
    },
    alpha: function alpha(paramValue, _alpha) {
        return paramValue.alpha(_alpha * paramValue.alpha());
    },

    //size
    decrease: function decrease(paramValue, decreaseFrom) {
        return _.parseInt(paramValue) - _.parseInt(decreaseFrom);
    },
    increase: function increase(paramValue, increaseFrom) {
        return _.parseInt(paramValue) + _.parseInt(increaseFrom);
    },
    multiply: function multiply(paramValue, multiplyOn) {
        return _.parseInt(paramValue) * parseFloat(multiplyOn);
    },
    max: function max(paramValue, maxValue) {
        return Math.max(_.parseInt(paramValue), _.parseInt(maxValue));
    },
    eval: function _eval(paramValue, expression, evaluators) {
        return evaluators[expression](paramValue);
    }
};

function applyMutator(paramValue, mutator, evals) {
    if (paramMutators[mutator.type]) {
        return paramMutators[mutator.type](paramValue, mutator.value, evals);
    }
    return paramValue;
}

function applyMutators(paramName, paramValue, paramsMutators, evaluators) {
    if (paramsMutators && paramsMutators[paramName]) {
        //TODO: multiply multiple alpha mutators before applying (like in Audio3dPlayer)
        var mutator = paramsMutators[paramName];

        return applyMutator(paramValue, mutator, evaluators);
    }
    return paramValue;
}

function isBoxShadowOff(paramName, styleData, paramsDefaults) {
    var shadowOnProp = 'boxShadowToggleOn-' + paramName;
    var isShadowOn = styleData[shadowOnProp] || paramsDefaults[shadowOnProp];
    return isShadowOn === 'false';
}

function limitBorderRadius(paramValue) {
    //FF and IE don't support css numbers larger than 17895697 (0x1111111); We limit to 99999 for good measure's sake
    //Also, make the fix only if we're dealing with data from style, since we assume data from skin will be OK

    var borderRadius = '';
    _.forEach(paramValue.replace(/px/g, '').split(' '), function (br) {
        var brValue = Math.min(_.parseInt(br), 99999);
        borderRadius += ' ' + brValue + (brValue === 0 ? '' : 'px');
    });

    paramValue = borderRadius.substring(1);
    return paramValue;
}

function handleColorParam(value, colors) {
    var colorParts = value.split('color_');
    if (colorParts.length === 2) {
        value = colors[_.parseInt(colorParts[1])];
    }
    if (_.includes(value, ',') && !_.includes(value, 'rgb')) {
        value = 'rgba(' + value + ')';
    }
    return color(value);
}

function handleColorAlphaProp(value, paramName, paramsDefaults, styleData) {
    var mappedParamName = Array.isArray(paramsDefaults[paramName]) && paramsDefaults[paramName][0];
    var alphaProp = 'alpha-' + (mappedParamName || paramName);

    var alpha = !_.isUndefined(styleData[alphaProp]) ? styleData[alphaProp] : paramsDefaults[alphaProp];
    if (!_.isUndefined(alpha)) {
        value = paramMutators.alpha(value, parseFloat(alpha));
    }

    return value;
}

function getCssUnits(cssValue) {
    var numericValue = _.parseInt(cssValue).toString();
    cssValue = cssValue.toString();

    if (isNaN(numericValue) || cssValue === numericValue) {
        return '';
    }

    return cssValue.substr(cssValue.indexOf(numericValue) + numericValue.length);
}

function getParamValue(paramName, styleData, paramsDefaults) {
    var paramValue = !_.isUndefined(styleData[paramName]) ? styleData[paramName] : paramsDefaults[paramName];

    if (!_.isArray(paramValue)) {
        return paramValue;
    }

    if (paramValue.length === 1) {
        return styleData[paramValue[0]] || paramsDefaults[paramValue[0]];
    }

    var units = '';
    paramValue = _.reduce(paramValue, function (sum, parameterName) {
        var paramVal = styleData[parameterName] || paramsDefaults[parameterName];
        units = units || getCssUnits(paramVal);
        return sum + _.parseInt(paramVal);
    }, 0);

    if (units === 'x') {
        //not sure its needed, possibly because of corrupted data
        units = 'px';
    }

    return paramValue + units;
}

function renderParam(paramName, skinData, styleData, colors, evaluators) {
    if (!skinData.params) {
        return '';
    }

    var paramType = checkIsParamAnAliasAndGetUnaliasedValue(skinData.params[paramName]);
    var paramValue = getParamValue(paramName, styleData, skinData.paramsDefaults);

    if (typeof paramValue === 'undefined' || !paramType) {
        return '';
    }

    switch (paramType) {
        case 'BG_COLOR':
        case 'COLOR':
        case 'COLOR_ALPHA':
            paramValue = handleColorParam(paramValue, colors);
            paramValue = handleColorAlphaProp(paramValue, paramName, skinData.paramsDefaults, styleData);
            break;

        case 'BORDER_RADIUS':
            if (styleData[paramName]) {
                paramValue = limitBorderRadius(paramValue);
            }
            break;

        case 'BOX_SHADOW':
            if (isBoxShadowOff(paramName, styleData, skinData.paramsDefaults)) {
                return '';
            }
            break;

        default:
    }

    paramValue = applyMutators(paramName, paramValue, skinData.paramsMutators, evaluators);

    return {
        type: paramType,
        value: paramValue
    };
}

module.exports = { renderParam: renderParam };

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    createSkinCss: __webpack_require__(3),
    renderParam: __webpack_require__(1).renderParam
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var params = __webpack_require__(1);
var fontCss = __webpack_require__(6);

function defaultToPixelUnits(propValue) {
    return isNaN(propValue) ? propValue : propValue + 'px';
}

/**
 * param types:
 * BG_COLOR
 * BORDER_RADIUS
 * BOX_SHADOW
 * FONT
 * SIZE
 * COLOR
 * COLOR_ALPHA
 * TRANSITION
 * URL
 * OTHER param type is not in use.
 *
 * @param paramValue
 * @param {string} paramType BORDER_RADIUS
 * @param themeData
 * @param options
 * @return {*}
 */
function paramValueToCss(paramValue, paramType, themeData, _ref) {
    var renderingEnv = _ref.renderingEnv;

    if (_.isNil(paramValue)) {
        return '';
    }

    switch (paramType) {
        case 'BORDER_RADIUS':
            paramValue = 'border-radius:' + paramValue + ';';
            break;
        case 'BOX_SHADOW':
            paramValue = 'box-shadow:' + defaultToPixelUnits(paramValue) + ';';
            break;
        case 'FONT':
            paramValue = 'font:' + fontCss.fontToCSSWithoutColor(paramValue, themeData);
            break;
        case 'FONT_FAMILY':
            paramValue = 'font-family:' + fontCss.getFullFontFamily(paramValue) + ';';
            break;
        case 'SIZE':
            paramValue = defaultToPixelUnits(paramValue);
            break;
        case 'COLOR':
            paramValue = paramValue.hexString();
            break;
        case 'BG_COLOR':
        case 'COLOR_ALPHA':
            paramValue = paramValue.alpha() > 0 ? paramValue.rgbaString() : 'transparent';
            break;
        case 'TRANSITION':
            paramValue = 'transition: ' + paramValue + ';'; //transition is now prefix free http://caniuse.com/#feat=css-transitions
            break;
        case 'INVERTED_ZOOM':
            //paramValue = 'transform: scale(' + mobileData.getSiteZoomRatio() + ');';
            paramValue = 'zoom: ' + renderingEnv.siteZoomRatio + ';';
            break;
        case 'INVERTED_ZOOM_FIXED':
            // delete INVERTED_ZOOM (above) after implementation
            paramValue = 'zoom: ' + renderingEnv.invertedZoomRatio + ';';
            break;
        case 'ORIENTATION_ZOOM_FIX':
            paramValue = 'zoom: ' + renderingEnv.orientationZoomFix + ';';
            break;
        case 'ZOOM_BY_SCREEN_PROPERTIES':
            paramValue = 'zoom: ' + renderingEnv.mobileZoom + ';';
            break;
        case 'URL':
            if (paramValue === 'BASE_THEME_DIRECTORY') {
                return renderingEnv.baseThemeUrl;
            } else if (paramValue === 'WEB_THEME_DIRECTORY') {
                return renderingEnv.webThemeUrl;
            }

            return paramValue;
        case 'ALPHA':
            // do nothing
            break;
        case 'BORDER_SIDES':
        case 'ICON_TYPE':
            paramValue = ''; // we need to mock mixin variable in order to create element in design panel
            break;
    }
    return paramValue;
}

function getParamSplit(prop, skinData, styleProps, themeData, options) {
    var param = params.renderParam(prop, skinData, styleProps, themeData.color, options.evals);
    var paramsSplit = param.type === 'SIZE' && _.isString(param.value) ? _.map(param.value.split(' '), function (value) {
        return {
            value: value,
            type: 'SIZE'
        };
    }) : [param];

    return _.map(paramsSplit, function (paramToMap) {
        return paramValueToCss(paramToMap.value, paramToMap.type, themeData, options);
    });
}

/***
 *
 * @param skinCssValue
 * @param skinData
 * @param styleProps
 * @param themeData
 * @param options
 * @returns {string} the compiled css definitions without [p1] expressions
 */
function handleParams(skinCssValue, skinData, styleProps, themeData, options) {
    return skinCssValue.replace(/\[(.*?)\]/g, function (full, prop) {
        var param = params.renderParam(prop, skinData, styleProps, themeData.color, options.evals);
        return paramValueToCss(param.value, param.type, themeData, options);
    });
}

/***
 *
 * @param skinCssValue
 * @param skinData
 * @param styleProps
 * @param themeData
 * @param options
 * @returns {string} the compiled css definitions without calc([p1] + [p2]) expressions
 */
function handleCalcWithParams(skinCssValue, skinData, styleProps, themeData, options) {
    //e.g: replace calc([p1] - [p2]) when p1 is '10px 11px 12px 13px' and p2=3px, to "calc(10px - 3px) calc(11px - 3px) calc(12px - 3px) calc(13px - 3px)"
    //both p1 and p2 can be of multiple values
    return skinCssValue.replace(/calc\(\[([\w\d]+)\] ([-+*\/]) \[([\w\d]+)\]\)/g, function (full, prop1, calcSign, prop2) {
        var param1Split = getParamSplit(prop1, skinData, styleProps, themeData, options);
        var param2Split = getParamSplit(prop2, skinData, styleProps, themeData, options);

        var cssTemplate = _.template('calc(${p1} ${sign} ${p2})');
        var cssValue = [];

        for (var i = 0; i < Math.max(param1Split.length, param2Split.length); i++) {
            cssValue.push(cssTemplate({
                p1: param1Split[i] || param1Split[0],
                p2: param2Split[i] || param2Split[0],
                sign: calcSign
            }));
        }

        return cssValue.join(' ');
    });
}

/***
 *
 * @param cssVal
 * @param styleId
 * @returns {*}
 */
function handleAnimationReferences(cssVal, styleId) {
    return cssVal.replace(/((-webkit-)?animation(-name)?: ?)/mgi, '$1' + styleId + '_');
}

/**
 * Transform Media Object to Css Media Query
 *
 * @param skinData
 * @param styleData
 * @param themeData
 * @param styleName
 */
function renderSkinMediaQueries(skinData, styleData, themeData, styleName) {
    if (!skinData.mediaQueries || !skinData.mediaQueries.length) {
        return '';
    }

    return _.map(skinData.mediaQueries, function (media) {
        var css = createSkinCss({ css: media.css }, styleData, themeData, styleName);
        return [media.query, '{', css, '}'].join('');
    }).join('\n');
}

/***
 *
 * @param skinData
 * @param styleProps
 * @param themeData
 * @param styleId
 * @param mobileData
 * @param serviceTopology
 * @returns {string} the compiled css definitions for the skin (after applying params, etc)
 */
function renderSkinCssRules(skinData, styleProps, themeData, styleId, options) {
    return _.map(skinData.css, function (cssVal, cssSelector) {
        var prefix = cssSelector[0] === '@' ? styleId + '_' : '.' + styleId;
        cssSelector = cssSelector.replace(/%/g, prefix);

        cssVal = handleCalcWithParams(cssVal, skinData, styleProps, themeData, options);
        cssVal = handleParams(cssVal, skinData, styleProps, themeData, options);
        cssVal = handleAnimationReferences(cssVal, styleId);

        return cssSelector + ' {' + cssVal + '}';
    }).join('\n');
}

/**
 * @typedef {{
 *  siteZoomRatio: {Number},
 *  invertedZoomRatio: {Number},
 *  orientationZoomFix: {Number},
 *  mobileZoom: {Number},
 *  baseThemeUrl: {string},
 *  webThemeUrl: {string}
 * }} envOptions
 */

/**
 *
 * @param {Object}skinJsonObj
 * @param {Object}styleData
 * @param {{font: string[], color:string[]}}themeData
 * @param {string} styleId
 * @param {{renderingEnv: envOptions, evals: <string, function>}}options
 * @returns {string} compiled css
 */
function createSkinCss(skinJsonObj, styleData, themeData, styleId) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { evals: {} };

    return renderSkinCssRules(skinJsonObj, styleData, themeData, styleId, options) + renderSkinMediaQueries(skinJsonObj, styleData, themeData, styleId, options);
}

module.exports = createSkinCss;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var SIZE_ALIASES = ['BORDER_SIZE', 'BORDER_TOP_SIZE', 'BORDER_BOTTOM_SIZE', 'BORDER_LEFT_SIZE', 'BORDER_RIGHT_SIZE', 'PADDING_SIZE', 'PADDING_TOP_SIZE', 'PADDING_BOTTOM_SIZE', 'PADDING_LEFT_SIZE', 'PADDING_RIGHT_SIZE', 'MARGIN_SIZE', 'MARGIN_TOP_SIZE', 'MARGIN_BOTTOM_SIZE', 'MARGIN_LEFT_SIZE', 'MARGIN_RIGHT_SIZE', 'BG_SIZE', 'WIDTH_SIZE', 'HEIGHT_SIZE', 'TOP_SIZE', 'BOTTOM_SIZE', 'LEFT_SIZE', 'RIGHT_SIZE', 'TEXT_SIZE'];
var COLOR_ALIASES = ['TEXT_COLOR', 'BORDER_COLOR'];
var COLOR_ALPHA_ALIASES = ['BORDER_COLOR_ALPHA', 'BOX_SHADOW_COLOR_ALPHA', 'TEXT_COLOR_LEGACY_ALPHA'];

var BG_COLOR_ALIASES = ['BG_COLOR_ALPHA'];

var PARAM_ALIAS_MAP = {};

_.forEach(SIZE_ALIASES, function (alias) {
    PARAM_ALIAS_MAP[alias] = 'SIZE';
});
_.forEach(COLOR_ALIASES, function (alias) {
    PARAM_ALIAS_MAP[alias] = 'COLOR';
});
_.forEach(COLOR_ALPHA_ALIASES, function (alias) {
    PARAM_ALIAS_MAP[alias] = 'COLOR_ALPHA';
});
_.forEach(BG_COLOR_ALIASES, function (alias) {
    PARAM_ALIAS_MAP[alias] = 'BG_COLOR';
});

var checkIsParamAnAliasAndGetUnaliasedValue = function checkIsParamAnAliasAndGetUnaliasedValue(param) {
    if (PARAM_ALIAS_MAP[param]) {
        return PARAM_ALIAS_MAP[param];
    }

    return param;
};

module.exports = {
    checkIsParamAnAliasAndGetUnaliasedValue: checkIsParamAnAliasAndGetUnaliasedValue,
    PARAM_ALIAS_MAP: PARAM_ALIAS_MAP,
    SIZE_ALIASES: SIZE_ALIASES,
    COLOR_ALIASES: COLOR_ALIASES,
    COLOR_ALPHA_ALIASES: COLOR_ALPHA_ALIASES,
    BG_COLOR_ALIASES: BG_COLOR_ALIASES
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(7); // This has a special rule for external in webpack.config - check it out if it you change this path
var fontUtils = coreUtils.fonts;

function getFullFontFamily(fontFamily) {
    var fullFontFamily = fontFamily;
    var fallback = fontUtils.getFontFallback(fontFamily);
    if (fallback) {
        fullFontFamily = fullFontFamily + ',' + fallback;
    }

    //surround fonts with quotes if font name contains spaces or non-latin chars
    fullFontFamily = fullFontFamily.replace(/[^,]*[^\w,\d\-][^,]*/g, function (fontFamilyStr) {
        return '\'' + fontFamilyStr.replace(/\+/g, ' ') + '\'';
    });
    return fullFontFamily;
}

function getFontCSSFromFontString(fontVal) {
    var font = fontVal;
    if (_.includes(font, '#')) {
        font = font.slice(0, font.indexOf('#'));
    }
    font = font.replace(/\{color_\d+\}/, '');
    var fontFamily = fontUtils.getFontFamily(font);
    var fullFontFamily = getFullFontFamily(fontFamily);
    var childFont = font.replace(fontFamily, fullFontFamily);
    return childFont + ';';
}

/**
 *
 * @param fontString
 * @param {{color: string[], font: []}} themeData
 * @returns {*}
 */
function getFontVal(fontString, themeData) {
    if (_.startsWith(fontString, 'font_')) {
        var fontParts = fontString.split('font_');
        if (fontParts.length === 2) {
            return themeData.font[fontParts[1]];
        }
    }
    return fontString;
}

/**
 *
 * @param fontString
 * @param themeData
 * @returns {*}
 */
function fontToCSSWithoutColor(fontString, themeData) {
    var fontVal = getFontVal(fontString, themeData);
    return getFontCSSFromFontString(fontVal);
}

module.exports = {
    fontToCSSWithoutColor: fontToCSSWithoutColor,
    getFullFontFamily: getFullFontFamily
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// skin-utils.js